import CourseClients from './CourseClients';

export default CourseClients;
